import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select } from "arv-reactcomponents";
import { withRouter } from "react-router";

import { getPageDetails } from "../../utils";

@withRouter
class StaticPageMobileLeftNav extends Component {
  static getList(item) {
    return (
      <li
        className="nw-sample-select-list nw-staticpage-dropdown-option"
        key={item}
      >
        {item}
      </li>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      selectSelectedValue: " ",
      pageContent: "",
    };

    this.getPathName = this.getPathName.bind(this);
    this.getSelectSelection = this.getSelectSelection.bind(this);
    this.setHashValue = this.setHashValue.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  componentDidMount() {
    const pathname = this.getPathName();
    const result = getPageDetails(pathname);
    const [temp] =
      (result && result.mobileLeftNav && result.mobileLeftNav.navListItems) || [];
    this.setState({
      selectSelectedValue: temp,
      pageContent: result,
    });
  }

  getPathName() {
    return this.props.location.pathname;
  }

  getSelectSelection(selectedValue) {
    this.setState({
      selectSelectedValue: selectedValue,
    });
    this.setHashValue(selectedValue);
  }

  setHashValue(selectedValue) {
    const pathName = this.getPathName();
    if (pathName) {
      const pageData = getPageDetails(pathName);
      const leftNavItem =
        pageData && pageData.leftNav && pageData.leftNav.navListItems
          ? pageData.leftNav.navListItems.find(
              item => item.text === selectedValue,
            )
          : {};
      this.elementId = leftNavItem && leftNavItem.url ? leftNavItem.url : "";
      window.location.hash = this.elementId;
    }
  }

  getTitle(data) {
    const { pageContent } = this.state;
    switch (data) {
      case "title":
        return pageContent &&
          pageContent.mobileLeftNav &&
          pageContent.mobileLeftNav.title &&
          pageContent.mobileLeftNav.title.length > 0
          ? pageContent.mobileLeftNav.title
          : "";
      case "leftNav":
        return pageContent &&
          pageContent.mobileLeftNav &&
          pageContent.mobileLeftNav.title &&
          pageContent.mobileLeftNav.navListItems.length > 0
          ? pageContent.mobileLeftNav.navListItems
          : [];
      default:
        return "";
    }
  }

  render() {
    const { selectSelectedValue } = this.state;
    if (!this.getTitle("leftNav") || this.getTitle("leftNav").length === 0) {
      return null;
    }
    return (
      <div className="nw-staticpage-select">
        <div className="nw-staticpage-leftnav-title">
          {this.getTitle("title")}
        </div>
        <Select
          id="nw-staticpage-dropdown"
          className="nwc-select-lg nw-staticpage-dropdown"
          selectedValue={selectSelectedValue}
          inpList={this.getTitle("leftNav")}
          getSelection={this.getSelectSelection}
          renderList={StaticPageMobileLeftNav.getList}
        />
      </div>
    );
  }
}

StaticPageMobileLeftNav.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StaticPageMobileLeftNav,
  component: StaticPageMobileLeftNav,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StaticPageMobileLeftNav/index.js